import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  PerPageContainer,
  PerPage,
} from 'components/grid/list/components/pagination/style';
import { H3 } from 'components/typography';
import { withTranslation } from 'i18n';
import { map, noop } from 'lodash';

class PerPageList extends Component<any> {
  static propTypes = {
    onPerPageChange: PropTypes.func,
    perPage: PropTypes.number,
    perPageOptions: PropTypes.arrayOf(PropTypes.number),
    render: PropTypes.func,
  };

  static defaultProps = {
    onPerPageChange: noop,
    perPage: undefined,
    perPageOptions: [10, 25, 50],
    render: undefined,
  };

  perPageChanged = (perPage) => () => {
    this.props.onPerPageChange(perPage);
  };

  render() {
    const { perPage, perPageOptions, render } = this.props;

    if (render) {
      return render.call(this);
    }
    return (
      <PerPageContainer data-type="per-page-list">
        <H3>{this.props.t('Results per page')}</H3>
        <span>
          {map(perPageOptions, (value) => {
            return (
              <PerPage
                key={value}
                selected={value === perPage}
                onClick={this.perPageChanged(value)}
                data-type={`per-page-${value}`}>
                {value}
              </PerPage>
            );
          })}
        </span>
      </PerPageContainer>
    );
  }
}

export default withTranslation()(PerPageList);
